import React, { useState } from 'react';
import { TextField, IconButton, Tooltip, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

export const CustomDateInput = ({
	label,
	name,
	value,
	onChange,
	disabled = false,
	error = '',
}) => {
	const [tooltipOpen, setTooltipOpen] = useState(false);

	const handleDateChange = (date) => {
		const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
		onChange(formattedDate);
	};

	const handleClear = () => onChange(null);

	const handleKeyPress = (e) => {
		e.preventDefault();
		setTooltipOpen(true);
		setTimeout(() => setTooltipOpen(false), 2000);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DesktopDatePicker
				label={label}
				value={value ? moment(value, 'YYYY-MM-DD') : null}
				onChange={handleDateChange}
				inputFormat='DD/MM/YYYY'
				disabled={disabled}
				renderInput={(params) => (
					<Tooltip
						open={tooltipOpen}
						title='Selecciona la fecha con el calendario.'
						arrow
					>
						<TextField
							{...params}
							name={name}
							error={!!error}
							helperText={error}
							onKeyPress={handleKeyPress}
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										{value && (
											<InputAdornment position='end'>
												<Tooltip
													title='Borrar fecha'
													arrow
												>
													<IconButton
														onClick={handleClear}
													>
														<ClearIcon />
													</IconButton>
												</Tooltip>
											</InputAdornment>
										)}
										{params.InputProps.endAdornment}
									</>
								),
							}}
						/>
					</Tooltip>
				)}
			/>
		</LocalizationProvider>
	);
};
